import AdminTmtEventsList from './tmtEventsList';

export default AdminTmtEventsList;
